export const version = '__VERSION__'
export const sha = '__SHA__'
export const buildDate = '__BUILD_DATE__'
